/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import {registerInternalPlugin} from '@ciscospark/spark-core';
import Support from './support';
import config from './config';
import '@ciscospark/internal-plugin-wdm';

registerInternalPlugin('support', Support, {
  config
});

export {default} from './support';
